import { CURRENT_USERNAME, IS_LOGGED_IN_KEY, ROLES, SHOW_HINT, SHOW_MESSAGE } from "../../ducks/login";

import Header from "./Header";
import { LANGUAGE } from "../../ducks/languageSelector";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { doLogout } from "../../ducks/logout";
import { createErrorMessages, createSuccessMessages, createWarningMessages, messagesReceived } from "../../ducks/message";
import rest from "../../common/rest";

const mapStateToProps = (state) => {
  return {
    isLoggedIn: state.login[IS_LOGGED_IN_KEY],
    language: state.languageSelector[LANGUAGE],
    currentUsername: state.login[CURRENT_USERNAME],
    roles: state.login[ROLES],
    showHint: state.login[SHOW_HINT],
    showMessage: state.login[SHOW_MESSAGE]
  };
};

const showDowntimeNotification = () => messagesReceived(createWarningMessages("general.notification.downtime"));

const clearSurveyCaches = () => (dispatch) => {
  Promise.all([
    rest.doDelete("/admin/admin/surveys/caches"),
    rest.doDelete("/survey/evaluations/frequency/cache")
  ]).then(
    () => dispatch(messagesReceived(createSuccessMessages("header.clear.survey.caches.success"))),
    () => dispatch(messagesReceived(createErrorMessages("header.clear.survey.caches.error")))
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      doLogout,
      clearSurveyCaches,
      showDowntimeNotification
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
